"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandUrl = void 0;
exports.brandUrl = {
    localhost: 'http://localhost:8080',
    boticario: 'https://minhaloja.boticario.com.br',
    eudora: 'https://minhaloja.eudora.com.br',
    oui: 'https://minhaloja.ouiparis.com',
    euamomake: 'https://minhaloja.quemdisseberenice.com.br',
};
